import { createFileRoute } from '@tanstack/react-router'
import RxForm from '@/components/rx/RxForm';

export const Route = createFileRoute('/dashboard/fields/$fieldId/rx/new')({
  component: RouteComponent,
})
  
function RouteComponent() {
  return <RxForm />;
}
